import React, {useMemo} from 'react';
import {Label} from '@tempo/core';
import type {TdProps} from '@components/Table/core/Td';
import Td from '@components/Table/core/Td';
import {AlbumStatus} from '@deezer/next/services/api/Starmania/requests/album/types';

type StatusCellProps = {
	value: AlbumStatus;
} & TdProps;

const StatusCell = ({value, ...rest}: StatusCellProps) => {
	const label = useMemo(() => {
		// fixme translate
		switch (value) {
			case AlbumStatus.TAKEDOWN:
				return 'Takedown';
			case AlbumStatus.LIVE:
				return 'Live';
			default:
				return value;
		}
	}, [value]);
	return (
		<Td {...rest}>
			<Label variant={value === AlbumStatus.LIVE ? 'accent' : 'live'}>
				{label}
			</Label>
		</Td>
	);
};

export default StatusCell;
